import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../Context/GlobalContext";

const AboutUs = () => {
  const { translatedLabels, is4Life } = useContext(GlobalContext);
  const screenLabels = translatedLabels?.common;
  const appName = is4Life ? "Healthy 4Life AI" : "GlobalHealth Check AI";
  const webUrl = is4Life ? "https://healthy4life.ai/" : "https://globalhealthiq.ai";
  return (
    <div className="content-part">
      <h5>{appName}</h5>
      <h6 className="my-3">
        {screenLabels?.abt_us_2?.label_value || "App Version: 3.0"}
      </h6>

      <p className="mb-0">
        {screenLabels?.abt_us_3?.label_value ||
          "GlobalHealth Check AI App is an innovative easy-to-use wellness tool that puts health awareness directly in your hands. By harnessing the power of your devices camera and sophisticated AI analysis, our app provides a convenient way to track key wellness indicators. Our goal is to empower individuals to take an active role in their well-being by making personal data more accessible and understandable."}
      </p>

      <h5 className="mt-3">
        {screenLabels?.abt_us_4?.label_value || "Important Notice"}
      </h5>

      <p className="mb-0">
        {screenLabels?.abt_us_5?.label_value ||
          "This application is designed for fitness and general wellness informational purposes only. This App is not a medical ordiagnostic product and should not be used as a substitute for professional medical advice, diagnosis, or treatment. The information provided by this app is not intended to diagnose or treat any health condition. Always consult with a qualified healthcare provider regarding any medical concerns or before making any health-related decisions."}
      </p>

      <p className="my-3">
        {screenLabels?.abt_us_6?.label_value ||
          "To discover more about our technology, visit us online at"}
        <Link
          to={webUrl}
          className="ms-1 text-primary"
          target="blank"
        >
          {webUrl}
        </Link>
      </p>

      <div>
        <Link to={"/terms-condition"} className="text-decoration-none me-1">
          {screenLabels?.terms_of_use?.label_value || "Terms of Use"}
        </Link>{" "}
        |{" "}
        <Link to={"/privacy-policy"} className="ms-1 text-decoration-none">
          {screenLabels?.privacy_policy?.label_value || "Privacy Policy"}
        </Link>
      </div>
    </div>
  );
};

export default AboutUs;
